// extracted by mini-css-extract-plugin
export default {"About":"About_About__LeFbV","fadeInUp":"About_fadeInUp__rHnlu","hidden":"About_hidden__aZEaQ"};